<template>
  <div>
    <!--    <div style="font-size: 100px">404</div>-->
    <!--    <div class="align_center">-->
    <!--      <div class="card">-->
    <!--        <span>您没有权限访问本网站。尊敬的用户您好！请您先完成注册流程，再使用优行关爱小助手哦。</span>-->
    <!--      </div>-->
    <!--    </div>-->
    <AuthorityDialog :initialDialogVisible="true" @sendDialogActionValue="handleCloseDialog"></AuthorityDialog>
  </div>

</template>

<script>
import AuthorityDialog from "@/components/AuthorityDialog";

export default {
  name: '404Page',
  data() {
    return {};
  },
  components: {
    AuthorityDialog
  },
};
</script>

<style scoped>

.align_center {
  text-align: center;
}

/* 卡片式UI */
.card {
  width: 80%;
  height: 100%;
  padding: 15px;
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  background-color: #fff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}
</style>
